// React
import React from 'react';
// PropType
import PropTypes from 'prop-types';
// MUI
import { Typography, Grid } from '@material-ui/core';
// styles
import withStyles from '@material-ui/core/styles/withStyles';
import Divider from '@material-ui/core/Divider';
import isEmpty from 'lodash/isEmpty';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import styles from './styles';
import ADGMPanel from '../ADGMPanel';

function checkWithOfColoumn(fullWidth, EqualGaps, index) {
  const ColMap = {
    0: 5,
    1: 3,
  };
  if (fullWidth) {
    return 12;
  }

  if (EqualGaps) {
    return 4;
  }
  return ColMap[index];
}

function Body({ classes, Labels, fullWidth, EqualGaps }) {
  const Equalgaps = EqualGaps || Labels?.length > 3;

  return (
    !isEmpty(Labels) &&
    Labels?.map(({ label, value, component }, index) => (
      <>
        <Grid item xs={12} sm={checkWithOfColoumn(fullWidth, Equalgaps, index) || 4} key={label}>
          <Typography variant='body1' className={classes.label}>
            <ADGMItemDetails showLabelOnly={component} label={label} value={value} />
            {component && component}
          </Typography>
        </Grid>
        {fullWidth && index < Labels.length - 1 && <Divider className={classes.divider} />}
      </>
    ))
  );
}

const ADGMPanelLabelsAndValues = ({ classes, Labels, shouldShow = true, fullWidth, EqualGaps, children, ...rest }) => {
  return (
    shouldShow && (
      <ADGMPanel classes={classes} {...rest}>
        <Grid container spacing={fullWidth ? 4 : 2} className={classes.container}>
          <Body
            {...{
              classes,
              Labels,
              fullWidth,
              EqualGaps,
            }}
          />
          {children && (
            <Grid item xs={12}>
              {children}
            </Grid>
          )}
        </Grid>
      </ADGMPanel>
    )
  );
};

ADGMPanelLabelsAndValues.propTypes = {
  classes: PropTypes.object.isRequired,
  Labels: PropTypes.array.isRequired,
  shouldShow: PropTypes.bool,
  fullWidth: PropTypes.bool,
  children: PropTypes.node,
  EqualGaps: PropTypes.bool,
};

ADGMPanelLabelsAndValues.defaultProps = {
  fullWidth: false,
  children: null,
  shouldShow: true,
  EqualGaps: false,
};

export default withStyles(styles)(ADGMPanelLabelsAndValues);
